<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>
<script>
export default {
  name: 'App',
  props: {
    source: String
  },
  watch: {
    authenticated (val) {
      if (val !== null) {
        if (val) {
          this.$router.push(this.lastPage ? this.lastPage : '/home')
        } else {
          this.$router.push('/')
        }
      }
    },
    '$route' (val) {
      if (val.path && val.path !== '/') {
        this.$store.commit('setLastPage', val.path)
      }
      if (this.authenticated === false) {
        this.$router.push('/')
      }
    }
  },
  computed: {
    authenticated () {
      return this.$store.getters.authenticated
    },
    lastPage () {
      return this.$store.getters.lastPage
    }
  }
}
</script>
